
import { GripVertical } from "lucide-react";

export interface DragHandleProps {
  className?: string;
}

export function DragHandle({ className }: DragHandleProps) {
  return (
    <div className={`cursor-grab active:cursor-grabbing ${className || ""}`}>
      <GripVertical className="h-5 w-5 text-muted-foreground" />
    </div>
  );
}
